import React from 'react';
import { useLazyQuery } from '@grandvisionhq/graphql';
import { useGetDispatchDate } from '@grandvisionhq/shipping';
import { PICKUP_POINTS_BY_GEO_LOCATION } from '../operations/queries/pickup-points-by-geo-location.js';
import { PICKUP_POINTS_BY_POSTAL_CODE } from '../operations/queries/pickup-points-by-postal-code.js';

const SHIPPING_METHOD_KEY = 'pick-up-point';
const filterNullable = (points)=>points.filter((p)=>p !== null
    )
;
function useGetPickupPoints(itemsToBeShipped // Items that are expected to be shipped to the pickup point
) {
    const [data, setData] = React.useState(null);
    const [error, setError] = React.useState(null);
    const onError = (err)=>{
        setError(err);
    };
    const [getByGeoLocation, geoResult] = useLazyQuery(PICKUP_POINTS_BY_GEO_LOCATION, {
        onError
    });
    const [getByPostalCode, formResult] = useLazyQuery(PICKUP_POINTS_BY_POSTAL_CODE, {
        onError
    });
    /**
   * Get the estimated dispatch date of the items that are expected to be dispatched to
   * the pickup point, so we can send it to the pickup points api and filter pickup-points
   * that are closed on the estimated day the package will arrive at the pickup-point
   **/ const { dispatchDate  } = useGetDispatchDate(itemsToBeShipped !== null && itemsToBeShipped !== void 0 ? itemsToBeShipped : [], SHIPPING_METHOD_KEY);
    const getPickupPoints = React.useCallback(({ userCoords , formState  })=>{
        if (userCoords) {
            getByGeoLocation({
                variables: {
                    geoLocation: {
                        lat: userCoords.latitude,
                        lon: userCoords.longitude
                    },
                    shippingDate: dispatchDate
                }
            });
        } else if (formState === null || formState === void 0 ? void 0 : formState.postalCode) {
            getByPostalCode({
                variables: {
                    postalCodeInput: {
                        postalCode: formState.postalCode,
                        city: formState === null || formState === void 0 ? void 0 : formState.city
                    },
                    shippingDate: dispatchDate
                }
            });
        } else {
            console.error('Need either user coords or postalCode and city to fetch pickup points!');
        }
    }, [
        getByGeoLocation,
        getByPostalCode,
        dispatchDate
    ]);
    // useEffects below are a workaround because using onCompleted as a callback on useQuery doesn't
    // get invoked when the result is cached currently respond to changes in geo location data
    React.useEffect(()=>{
        var ref;
        const pickupPoints = (ref = geoResult.data) === null || ref === void 0 ? void 0 : ref.pickupPointsByGeoLocation;
        if (pickupPoints) {
            setError(null);
            setData(filterNullable(pickupPoints));
        }
    }, [
        geoResult.data
    ]);
    // Respond to changes in geo form state result data
    React.useEffect(()=>{
        var ref;
        const pickupPoints = (ref = formResult.data) === null || ref === void 0 ? void 0 : ref.pickupPointsByPostalCode;
        if (pickupPoints) {
            setError(null);
            setData(filterNullable(pickupPoints));
        }
    }, [
        formResult.data
    ]);
    const called = geoResult.called || formResult.called;
    const loading = geoResult.loading || formResult.loading;
    const noResultsFound = called && !loading && Array.isArray(data) && data.length === 0;
    return [
        getPickupPoints,
        {
            loading,
            error: error !== null ? error : undefined,
            noResultsFound,
            pickupPoints: data !== null && data !== void 0 ? data : []
        }, 
    ];
}

export { useGetPickupPoints };
//# sourceMappingURL=use-get-pickup-points.js.map
